/**
 * Debug utility for conditional logging
 * In production, only logs errors and warnings unless DEBUG=true
 */

const isDebugEnabled = (): boolean => {
  return (
    process.env.NODE_ENV === 'development' || 
    process.env.REACT_APP_DEBUG === 'true' ||
    (typeof localStorage !== 'undefined' && localStorage.getItem('debug') === 'true')
  )
}

export const debug = {
  log: (...args: any[]) => {
    if (isDebugEnabled()) {
      console.log(...args)
    }
  },
  warn: (...args: any[]) => {
    console.warn(...args)
  },
  error: (...args: any[]) => {
    console.error(...args)
  },
  info: (...args: any[]) => {
    if (isDebugEnabled()) {
      console.info(...args)
    }
  },
  group: (label: string) => {
    if (isDebugEnabled()) {
      console.group(label)
    }
  },
  groupEnd: () => {
    if (isDebugEnabled()) {
      console.groupEnd()
    }
  },
  table: (data: any) => {
    if (isDebugEnabled()) {
      console.table(data)
    }
  },
}

